var _rect, _tspan, _rect2, _rect3, _rect4, _path, _g, _rect5, _tspan2, _rect6, _rect7, _rect8, _path2, _rect9, _rect10, _tspan3, _rect11, _rect12, _rect13, _rect14, _tspan4, _rect15, _rect16, _rect17, _rect18, _tspan5, _rect19, _rect20, _rect21, _rect22, _tspan6, _rect23, _rect24, _rect25, _rect26, _tspan7, _rect27, _tspan8, _rect28, _tspan9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidgetList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 280,
    viewBox: "0 0 95.25 74.083",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-34.078 -3.5805)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75656 0 0 .65608 -22.963 53.788)",
    strokeWidth: 0.27554
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 159.92,
    y: -70.414,
    width: 38.635,
    height: 16.938,
    rx: 1.3989,
    ry: 1.6131,
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.27554
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 173.45996,
    y: -51.596931,
    fill: "#0070e0",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    opacity: 0.75,
    strokeMiterlimit: 10,
    strokeWidth: 0,
    textDecoration: "underline",
    style: {
      lineHeight: 0,
      textDecorationColor: "#0070e0",
      textDecorationLine: "underline"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 173.45996,
    y: -51.596931,
    fill: "#0070e0",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    strokeWidth: 0
  }, "View More"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 188.31,
    y: -63.209,
    width: 8.3932,
    height: 3.6295,
    rx: 1.5737,
    ry: 1.8147,
    fill: "#f66"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 161.06,
    y: -63.209,
    width: 24.48,
    height: 3.6295,
    rx: 1.5737,
    ry: 1.8147,
    fill: "#ffba66"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 85.96,
    y: 9.8773,
    width: 41.877,
    height: 23.297,
    rx: 1.3989,
    ry: 1.6131,
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.14866
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m85.96 14.666h41.761",
    fill: "none",
    stroke: "#3d4193",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.14866
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 87.083,
    y: 10.968,
    width: 11.767,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#0100ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.85,
    y: 10.968,
    width: 11.767,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.62,
    y: 10.968,
    width: 11.767,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.083,
    y: 15.943,
    width: 10.383,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#6766ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.85,
    y: 15.943,
    width: 11.075,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#ffcb66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.62,
    y: 15.943,
    width: 11.767,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#f66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.083,
    y: 19.451,
    width: 8.306,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#33f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.85,
    y: 19.451,
    width: 8.306,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#ffba33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.62,
    y: 19.451,
    width: 8.306,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#f33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.083,
    y: 22.958,
    width: 10.383,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#4c4cff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.85,
    y: 22.958,
    width: 10.383,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#ffc34c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.62,
    y: 22.958,
    width: 10.383,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.083,
    y: 26.465,
    width: 11.075,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#0200ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.85,
    y: 26.465,
    width: 9.6904,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.62,
    y: 26.465,
    width: 9.6904,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.083,
    y: 29.972,
    width: 10.383,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#8080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.85,
    y: 29.972,
    width: 10.383,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#ffd480"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.62,
    y: 29.972,
    width: 8.9982,
    height: 2.3945,
    rx: 1.3989,
    ry: 1.6131,
    fill: "#ff8080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.738-5.0621h-2.0983v2.4197h-0.69943v-2.4197h-2.0983v-0.80655h2.0983v-2.4197h0.69943v2.4197h2.0983z",
    fill: "#392781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.68-21.271 2.2414 2.5837h-5.2471v1.7646h5.2471l-2.2414 2.5837 1.191 1.3734 4.1966-4.8393-4.1966-4.8393z",
    fill: "#392781"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 86.023,
    y: -13.477,
    width: 38.635,
    height: 16.938,
    rx: 1.3989,
    ry: 1.6131,
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.27554
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 94.105515,
    y: 1.4249831,
    fill: "#0070e0",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    opacity: 0.75,
    strokeMiterlimit: 10,
    strokeWidth: 0,
    textDecoration: "underline",
    style: {
      lineHeight: 0,
      textDecorationColor: "#0070e0",
      textDecorationLine: "underline"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 94.105515,
    y: 1.4249831,
    fill: "#0070e0",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    strokeWidth: 0
  }, "View More"))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 114.42,
    y: -6.272,
    width: 8.3932,
    height: 3.6295,
    rx: 1.5737,
    ry: 1.8147,
    fill: "#f00"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 87.164,
    y: -6.272,
    width: 24.48,
    height: 3.6295,
    rx: 1.5737,
    ry: 1.8147,
    fill: "#ff8c00"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 87.185,
    y: -12.38,
    width: 20.983,
    height: 4.8393,
    rx: 2.0983,
    ry: 2.4197,
    fill: "#0100ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m82.738 22.248h-2.0983v2.4197h-0.69943v-2.4197h-2.0983v-0.80655h2.0983v-2.4197h0.69943v2.4197h2.0983z",
    fill: "#392781"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 161.06,
    y: -69.072,
    width: 20.983,
    height: 4.8393,
    rx: 2.0983,
    ry: 2.4197,
    fill: "#6766ff"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 159.92,
    y: -48.903,
    width: 38.635,
    height: 16.938,
    rx: 1.3989,
    ry: 1.6131,
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.27554
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 173.45996,
    y: -31.565084,
    fill: "#0070e0",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    opacity: 0.75,
    strokeMiterlimit: 10,
    strokeWidth: 0,
    textDecoration: "underline",
    style: {
      lineHeight: 0,
      textDecorationColor: "#0070e0",
      textDecorationLine: "underline"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 173.45996,
    y: -31.565084,
    fill: "#0070e0",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    strokeWidth: 0
  }, "View More"))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 188.31,
    y: -41.698,
    width: 8.3932,
    height: 3.6295,
    rx: 1.5737,
    ry: 1.8147,
    fill: "#f33"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 161.06,
    y: -41.698,
    width: 24.48,
    height: 3.6295,
    rx: 1.5737,
    ry: 1.8147,
    fill: "#ffa333"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 161.06,
    y: -47.56,
    width: 20.983,
    height: 4.8393,
    rx: 2.0983,
    ry: 2.4197,
    fill: "#3433ff"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 159.92,
    y: -27.392,
    width: 38.635,
    height: 16.938,
    rx: 1.3989,
    ry: 1.6131,
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.27554
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 173.45996,
    y: -11.533235,
    fill: "#0070e0",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    opacity: 0.75,
    strokeMiterlimit: 10,
    strokeWidth: 0,
    textDecoration: "underline",
    style: {
      lineHeight: 0,
      textDecorationColor: "#0070e0",
      textDecorationLine: "underline"
    },
    xmlSpace: "preserve"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 173.45996,
    y: -11.533235,
    fill: "#0070e0",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    strokeWidth: 0
  }, "View More"))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 188.31,
    y: -20.187,
    width: 8.3932,
    height: 3.6295,
    rx: 1.5737,
    ry: 1.8147,
    fill: "#ff4c4c"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 161.06,
    y: -20.187,
    width: 24.48,
    height: 3.6295,
    rx: 1.5737,
    ry: 1.8147,
    fill: "#ffae4c"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 161.06,
    y: -26.049,
    width: 20.983,
    height: 4.8393,
    rx: 2.0983,
    ry: 2.4197,
    fill: "#4d4cff"
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 159.92,
    y: -5.8806,
    width: 38.635,
    height: 16.938,
    rx: 1.3989,
    ry: 1.6131,
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.27554
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 173.45996,
    y: 8.4986153,
    fill: "#0070e0",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    opacity: 0.75,
    strokeMiterlimit: 10,
    strokeWidth: 0,
    textDecoration: "underline",
    style: {
      lineHeight: 0,
      textDecorationColor: "#0070e0",
      textDecorationLine: "underline"
    },
    xmlSpace: "preserve"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 173.45996,
    y: 8.4986153,
    fill: "#0070e0",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    strokeWidth: 0
  }, "View More"))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 188.31,
    y: 1.324,
    width: 8.3932,
    height: 3.6295,
    rx: 1.5737,
    ry: 1.8147,
    fill: "#f00"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 161.06,
    y: 1.324,
    width: 24.48,
    height: 3.6295,
    rx: 1.5737,
    ry: 1.8147,
    fill: "#ff8c00"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 161.06,
    y: -4.5381,
    width: 20.983,
    height: 4.8393,
    rx: 2.0983,
    ry: 2.4197,
    fill: "#0100ff"
  }))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 159.92,
    y: 15.631,
    width: 38.635,
    height: 16.938,
    rx: 1.3989,
    ry: 1.6131,
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.27554
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 173.45996,
    y: 28.530464,
    fill: "#0070e0",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    opacity: 0.75,
    strokeMiterlimit: 10,
    strokeWidth: 0,
    textDecoration: "underline",
    style: {
      lineHeight: 0,
      textDecorationColor: "#0070e0",
      textDecorationLine: "underline"
    },
    xmlSpace: "preserve"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 173.45996,
    y: 28.530464,
    fill: "#0070e0",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.286px",
    strokeWidth: 0
  }, "View More"))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 188.31,
    y: 22.835,
    width: 8.3932,
    height: 3.6295,
    rx: 1.5737,
    ry: 1.8147,
    fill: "#ff8080"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 161.06,
    y: 22.835,
    width: 24.48,
    height: 3.6295,
    rx: 1.5737,
    ry: 1.8147,
    fill: "#ffc580"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 161.06,
    y: 16.973,
    width: 20.983,
    height: 4.8393,
    rx: 2.0983,
    ry: 2.4197,
    fill: "#8080ff"
  }))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 86.006,
    y: -72.719,
    width: 33.756,
    height: 14.799,
    rx: 1.3989,
    ry: 1.6131,
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.24074
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 109.0351,
    y: -57.717949,
    fill: "#b2b2b2",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "6.5624px",
    strokeMiterlimit: 10,
    strokeWidth: 0.09041,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 109.0351,
    y: -57.717949,
    fill: "#b2b2b2",
    fontSize: "6.5624px",
    strokeWidth: 0.09041
  }, "?"))), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 86.006,
    y: -53.924,
    width: 33.756,
    height: 14.799,
    rx: 1.3989,
    ry: 1.6131,
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "square",
    strokeWidth: 0.24074
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 109.0351,
    y: -40.982601,
    fill: "#b2b2b2",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "6.5624px",
    strokeWidth: 0.09041,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 109.0351,
    y: -40.982601,
    fill: "#b2b2b2",
    fontSize: "6.5624px",
    strokeWidth: 0.09041
  }, "?"))), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 86.006,
    y: -35.129,
    width: 33.756,
    height: 14.799,
    rx: 1.3989,
    ry: 1.6131,
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "square",
    strokeWidth: 0.24074
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.93123 1.0738)",
    x: 109.0351,
    y: -23.480286,
    fill: "#b2b2b2",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "6.5624px",
    strokeWidth: 0.09041,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 109.0351,
    y: -23.480286,
    fill: "#b2b2b2",
    fontSize: "6.5624px",
    strokeWidth: 0.09041
  }, "?")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetList);
export default __webpack_public_path__ + "static/media/widget-list.42ce64118cf4f89b49f205983b89a300.svg";
export { ForwardRef as ReactComponent };